import React from 'react';
import styled from 'styled-components';
import Option from '../Option';
const StyledContainer = styled.div `
  display: inline-flex;
  flex-direction: column;
  min-width: 13.333333333rem;
  padding: 0.666666667rem 0;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.16);
`;
const StyledOption = styled(Option) `
  &:not(:last-child) {
    margin-bottom: 0.333333333rem;
  }
`;
const renderOptions = (options, onOptionClick, optionClassName) => options.map((option) => (React.createElement(StyledOption, { key: option.name, className: optionClassName, option: option, onClick: onOptionClick })));
const Menu = ({ className, optionClassName, options, onOptionClick, }) => (React.createElement(StyledContainer, { className: className }, renderOptions(options, onOptionClick, optionClassName)));
export default Menu;
